import { render, staticRenderFns } from "./HolidayCalendarLayout.vue?vue&type=template&id=3b3fcf9a&"
import script from "./HolidayCalendarLayout.vue?vue&type=script&lang=js&"
export * from "./HolidayCalendarLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports